import {gql} from "@apollo/client";
import {REWARDMAPPING_ENTITY} from "../entities/rewardMappingEntity";

export const CREATE_REWARDMAPPING = gql`
    ${REWARDMAPPING_ENTITY}
    mutation createRewardMapping($data: RewardMappingInput!) {
      createRewardMapping(data: $data) {...RewardMappingEntity}
    }
`;